import { Flex } from '@pairy/pds-react';
import styled from '@emotion/styled';

export const Wrapper = styled.div`
  position: relative;
  overflow: hidden;

  width: 530px;
  height: 289px;

  &:hover {
    cursor: pointer;
  }
`;

export const Overlay = styled(Flex)`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgb(79 88 96 / 50%);
`;
